export const UsStates = [
    {
        name: 'Alabama',
        abbreviation: 'AL',
    },
    {
        name: 'Alaska',
        abbreviation: 'AK',
    },
    // {
    //     name: "American Samoa",
    //     abbreviation: "AS",
    // },
    {
        name: 'Arizona',
        abbreviation: 'AZ',
    },
    {
        name: 'Arkansas',
        abbreviation: 'AR',
    },
    {
        name: 'California',
        abbreviation: 'CA',
    },
    {
        name: 'Colorado',
        abbreviation: 'CO',
    },
    {
        name: 'Connecticut',
        abbreviation: 'CT',
    },
    {
        name: 'Delaware',
        abbreviation: 'DE',
    },
    {
        name: 'District Of Columbia',
        abbreviation: 'DC',
    },
    // {
    //     name: "Federated States Of Micronesia",
    //     abbreviation: "FM",
    // },
    {
        name: 'Florida',
        abbreviation: 'FL',
    },
    {
        name: 'Georgia',
        abbreviation: 'GA',
    },
    {
        name: 'Guam',
        abbreviation: 'GU',
    },
    {
        name: 'Hawaii',
        abbreviation: 'HI',
    },
    {
        name: 'Idaho',
        abbreviation: 'ID',
    },
    {
        name: 'Illinois',
        abbreviation: 'IL',
    },
    {
        name: 'Indiana',
        abbreviation: 'IN',
    },
    {
        name: 'Iowa',
        abbreviation: 'IA',
    },
    {
        name: 'Kansas',
        abbreviation: 'KS',
    },
    {
        name: 'Kentucky',
        abbreviation: 'KY',
    },
    {
        name: 'Louisiana',
        abbreviation: 'LA',
    },
    {
        name: 'Maine',
        abbreviation: 'ME',
    },
    // {
    //     name: "Marshall Islands",
    //     abbreviation: "MH",
    // },
    {
        name: 'Maryland',
        abbreviation: 'MD',
    },
    {
        name: 'Massachusetts',
        abbreviation: 'MA',
    },
    {
        name: 'Michigan',
        abbreviation: 'MI',
    },
    {
        name: 'Minnesota',
        abbreviation: 'MN',
    },
    {
        name: 'Mississippi',
        abbreviation: 'MS',
    },
    {
        name: 'Missouri',
        abbreviation: 'MO',
    },
    {
        name: 'Montana',
        abbreviation: 'MT',
    },
    {
        name: 'Nebraska',
        abbreviation: 'NE',
    },
    {
        name: 'Nevada',
        abbreviation: 'NV',
    },
    {
        name: 'New Hampshire',
        abbreviation: 'NH',
    },
    {
        name: 'New Jersey',
        abbreviation: 'NJ',
    },
    {
        name: 'New Mexico',
        abbreviation: 'NM',
    },
    {
        name: 'New York',
        abbreviation: 'NY',
    },
    {
        name: 'North Carolina',
        abbreviation: 'NC',
    },
    {
        name: 'North Dakota',
        abbreviation: 'ND',
    },
    // {
    //     name: "Northern Mariana Islands",
    //     abbreviation: "MP",
    // },
    {
        name: 'Ohio',
        abbreviation: 'OH',
    },
    {
        name: 'Oklahoma',
        abbreviation: 'OK',
    },
    {
        name: 'Oregon',
        abbreviation: 'OR',
    },
    {
        name: 'Palau',
        abbreviation: 'PW',
    },
    {
        name: 'Pennsylvania',
        abbreviation: 'PA',
    },
    {
        name: 'Puerto Rico',
        abbreviation: 'PR',
    },
    {
        name: 'Rhode Island',
        abbreviation: 'RI',
    },
    {
        name: 'South Carolina',
        abbreviation: 'SC',
    },
    {
        name: 'South Dakota',
        abbreviation: 'SD',
    },
    {
        name: 'Tennessee',
        abbreviation: 'TN',
    },
    {
        name: 'Texas',
        abbreviation: 'TX',
    },
    {
        name: 'Utah',
        abbreviation: 'UT',
    },
    {
        name: 'Vermont',
        abbreviation: 'VT',
    },
    {
        name: 'Virgin Islands',
        abbreviation: 'VI',
    },
    {
        name: 'Virginia',
        abbreviation: 'VA',
    },
    {
        name: 'Washington',
        abbreviation: 'WA',
    },
    {
        name: 'West Virginia',
        abbreviation: 'WV',
    },
    {
        name: 'Wisconsin',
        abbreviation: 'WI',
    },
    {
        name: 'Wyoming',
        abbreviation: 'WY',
    },
]

export const costaRicaProvinces = [
    {
        name: 'Alajuela',
        abbreviation: 'AL',
    },
    {
        name: 'Cartago',
        abbreviation: 'CA',
    },
    {
        name: 'Heredia',
        abbreviation: 'HE',
    },
    {
        name: 'Guanacaste',
        abbreviation: 'GU',
    },
    {
        name: 'Limon',
        abbreviation: 'LI',
    },
    {
        name: 'Puntarenas',
        abbreviation: 'PU',
    },
    {
        name: 'San Jose',
        abbreviation: 'SJ',
    },
]

export const canadianProvinces = [
    {
        name: 'Alberta',
        abbreviation: 'AB',
    },
    {
        name: 'British Columbia',
        abbreviation: 'BC',
    },
    {
        name: 'Manitoba',
        abbreviation: 'MB',
    },
    {
        name: 'New Brunswick',
        abbreviation: 'NB',
    },
    {
        name: 'Newfoundland and Labrador',
        abbreviation: 'NL',
    },
    {
        name: 'Northwest Territories',
        abbreviation: 'NT',
    },
    {
        name: 'Nova Scotia',
        abbreviation: 'NS',
    },
    {
        name: 'Nunavut',
        abbreviation: 'NU',
    },
    {
        name: 'Ontario',
        abbreviation: 'ON',
    },
    {
        name: 'Prince Edward Island',
        abbreviation: 'PE',
    },
    {
        name: 'Quebec',
        abbreviation: 'QC',
    },
    {
        name: 'Saskatchewan',
        abbreviation: 'SK',
    },
    {
        name: 'Yukon',
        abbreviation: 'YT',
    },
]

export const AustraliaStates: {
    name: string
    abbreviation: string
}[] = [
    { name: 'New South Wales', abbreviation: 'NSW' },
    { name: 'Victoria', abbreviation: 'VIC' },
    { name: 'Queensland', abbreviation: 'QLD' },
    { name: 'Western Australia', abbreviation: 'WA' },
    { name: 'South Australia', abbreviation: 'SA' },
    { name: 'Tasmania', abbreviation: 'TAS' },
    { name: 'Australian Capital Territory', abbreviation: 'ACT' },
    { name: 'Northern Territory', abbreviation: 'NT' },
]

export const NewZealandRegions: {
    name: string
    abbreviation: string
}[] = [
    { name: 'Northland', abbreviation: 'Northland Region' },
    { name: 'Auckland', abbreviation: 'Auckland Region' },
    { name: 'Waikato', abbreviation: 'Waikato Region' },
    { name: 'Bay of Plenty', abbreviation: 'Bay of Plenty Region' },
    { name: 'Gisborne', abbreviation: 'Gisborne Region' },
    { name: "Hawke's Bay", abbreviation: "Hawke's Bay Region" },
    { name: 'Taranaki', abbreviation: 'Taranaki Region' },
    { name: 'Manawatu-Whanganui', abbreviation: 'Manawatu-Whanganui Region' },
    { name: 'Wellington', abbreviation: 'Wellington Region' },
    { name: 'Tasman', abbreviation: 'Tasman Region' },
    { name: 'Nelson', abbreviation: 'Nelson Region' },
    { name: 'Marlborough', abbreviation: 'Marlborough Region' },
    { name: 'West Coast', abbreviation: 'West Coast Region' },
    { name: 'Canterbury', abbreviation: 'Canterbury Region' },
    { name: 'Otago', abbreviation: 'Otago Region' },
    { name: 'Southland', abbreviation: 'Southland Region' },
]

export const SouthAfricaProvinces: {
    name: string
    abbreviation: string
}[] = [
    { name: 'Eastern Cape', abbreviation: 'EC' },
    { name: 'Free State', abbreviation: 'FS' },
    { name: 'Gauteng', abbreviation: 'GP' },
    { name: 'KwaZulu-Natal', abbreviation: 'KZN' },
    { name: 'Limpopo', abbreviation: 'LP' },
    { name: 'Mpumalanga', abbreviation: 'MP' },
    { name: 'Northern Cape', abbreviation: 'NC' },
    { name: 'North West', abbreviation: 'NW' },
    { name: 'Western Cape', abbreviation: 'WC' },
]

export const SingaporeRegions: {
    name: string
    abbreviation: string
}[] = [
    { name: 'Central Region', abbreviation: 'Central Region' },
    { name: 'East Region', abbreviation: 'East Region' },
    { name: 'North Region', abbreviation: 'North Region' },
    { name: 'North-East Region', abbreviation: 'North-East Region' },
    { name: 'West Region', abbreviation: 'West Region' },
]

export function getStatesToUse(
    country: string | undefined | null,
): { name: string; abbreviation: string }[] {
    switch (country) {
        case 'United States':
            return UsStates
        case 'Canada':
            return canadianProvinces
        case 'Costa Rica':
            return costaRicaProvinces
        case 'Australia':
            return AustraliaStates
        case 'New Zealand':
            return NewZealandRegions
        case 'South Africa':
            return SouthAfricaProvinces
        case 'Singapore':
            return SingaporeRegions
        default:
            return UsStates
    }
}
